import { stringFormat } from "../../../../utils/string";

const StatusLabelColors: any = {
  DRAFT: {
    color: "rgba(255, 168, 0, 1)",
    backgroundColor: "rgba(255, 238, 204, 1)",
  },
  REQUESTED: {
    color: "rgba(122, 208, 150, 1)",
    backgroundColor: "rgba(232, 255, 243, 1)",
  },
  COMPLETED: {
    color: "rgba(122, 208, 150, 1)",
    backgroundColor: "rgba(232, 255, 243, 1)",
  },
  OFFERED: {
    color: "rgba(230, 18, 151, 1)",
    backgroundColor: "rgba(230, 18, 151, 0.1)",
  },
  PENDING_EXERCISED: {
    color: "rgba(77, 123, 255, 1)",
    backgroundColor: "rgba(77, 123, 255, 0.1)",
  },
  WILLINGNESS_GIVEN: {
    color: "rgba(77, 123, 255, 1)",
    backgroundColor: "rgba(77, 123, 255, 0.1)",
  },
  WILLINGNESS_ACCEPTED: {
    color: "rgba(0, 180, 216, 1)",
    backgroundColor: "rgba(0, 180, 216, 0.12)",
  },
  SIGN_GIVEN: {
    color: "rgba(77, 123, 255, 1)",
    backgroundColor: "rgba(77, 123, 255, 0.1)",
  },
  ACCEPTED: {
    color: "rgba(122, 208, 150, 1)",
    backgroundColor: "rgba(232, 255, 243, 1)",
  },
  REJECTED: {
    color: "rgba(232, 89, 54, 1)",
    backgroundColor: "rgba(251, 227, 221, 1)",
  },
};

function TransactionStatusLabel({
  state,
  _className,
}: {
  state: string;
  _className?: string;
}) {
  state = state?.toUpperCase();
  return (
    <span
      className={`${
        _className ? `${_className}` : "h-4"
      } items-center capitalize min-w-10  rounded-sm font-medium text-center text-[9px]  leading-4 px-2 `}
      style={{
        color: StatusLabelColors?.[state]?.color,
        backgroundColor: StatusLabelColors?.[state]?.backgroundColor,
      }}
    >
      {stringFormat(state?.toLowerCase())}
    </span>
  );
}

export default TransactionStatusLabel;
